import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import { IBiometricException, ILocationException } from "../models"

class ExceptionStore extends EventEmitter {
	private BiometricException: IBiometricException
	private LocationException: ILocationException
	constructor() {
		super()
		this.setMaxListeners(0)
		this.BiometricException = null
		this.LocationException = null
	}

	receivedBiometricRecord(biometricException) {
		this.BiometricException = biometricException
		this.emit("change")
	}

	receivedLocationRecord(locationException) {
		this.LocationException = locationException
		this.emit("change")
	}

	getLocationException() {
		return this.LocationException
	}

	getBiometricException() {
		return this.BiometricException
	}

	handleActions(action) {
		switch (action.type) {
			case "RECEIVE_BIOMETRIC_EXCEPTION": {
				this.receivedBiometricRecord(action.biometricException)
				break
			}
			case "RECEIVE_LOCATION_EXCEPTION": {
				this.receivedLocationRecord(action.locationException)
				break
			}
		}
	}
}

const exceptionStore = new ExceptionStore()
dispatcher.register(exceptionStore.handleActions.bind(exceptionStore))

export default exceptionStore
